'use client';

import { Skeleton } from '@packages/shared/src/ui/Skeleton/Skeleton';

export const AddedProductLoadingFallback = () => (
  <div className="flex gap-2">
    <Skeleton className="h-[120px] w-[120px]" />
    <div className="flex flex-grow flex-col gap-2.5">
      <Skeleton className="h-5 w-full" />
      <Skeleton className="h-5 w-full" />
      <Skeleton className="h-5 w-[120px]" />
      <Skeleton className="h-5 w-[120px]" />
      <div className="flex flex-col gap-2 self-end">
        <Skeleton className="h-5 w-[100px]" />
        <Skeleton className="h-5 w-[100px]" />
      </div>
    </div>
  </div>
);
